export const PaymentMethod = {
    bank_transfer: '1',
    cash: '2',
};
const EXCEPT_PROVINCES = {
    // HP: 7,
    // QN: 18,
    // HD: 21,
    // HY: 24
};
const HCROUTES = {
    home: '',
    schedule: 'schedule',
    payment: 'payment',
    payment_result: 'payment-result',
    order: 'order',
};

const SCHEDULE_TYPE = {
    NOT_SELECT_SEATS: 1,
    CAN_SELECT_SEATS: 2,
};

export { HCROUTES, EXCEPT_PROVINCES, SCHEDULE_TYPE };
